export default "__VITE_ASSET__DwWjMQPh__"